export enum OverviewMode {
	DEFAULT = 'DEFAULT',
	QUICK_SELECT = 'QUICK_SELECT',
	PERIODONTAL = 'PERIODONTAL',
	PATHOLOGY = 'PATHOLOGY',
	RESTORATION = 'RESTORATION',
	CROWN = 'CROWN',
	ENDODONTIC = 'ENDODONTIC',
}
